var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-nav-bar"},[_c('van-nav-bar',{attrs:{"title":_vm.title,"left-arrow":""},on:{"click-left":_vm.onBack}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }